/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../../../app/modules/auth'
import { Languages } from './Languages'
import { toAbsoluteUrl } from '../../../helpers'
import { LanguageHelp } from '../../../../_metronic/helpers/LanguageHelper'
import { getUserRole } from '../../../../_metronic/helpers/utility'

const HeaderUserMenu: FC = () => {
  const { auth, logout } = useAuth()
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl(auth!.result.avatarUrl)} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {auth?.result.name} {auth?.result.surname}
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {getUserRole(auth?.result.role)}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <Languages />

      <div className='menu-item px-5'>
        <Link to={'/crafted/account/profile'} className='menu-link px-5'>
          {LanguageHelp('My Profile')}
        </Link>
      </div>

      <div className='menu-item px-5'>
        <Link to='/crafted/account/company' className='menu-link px-5'>
          {LanguageHelp('Account Settings')}
        </Link>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          {LanguageHelp('Sign Out')}
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
